import { useEffect, useLayoutEffect, useRef, useState } from "react";

// Distance from the top of `container`, unaffected by any scrolling (offsetTop is layout-based).
// A screen-relative position (getBoundingClientRect) was wrong once iOS scrolled the page:
// the list grew by the scrolled amount, which let the page scroll further.
const getTopWithin = (element, container) => {
  let top = 0;
  for (let current = element; current && current !== container; current = current.offsetParent) {
    top += current.offsetTop;
  }
  return top;
};

// Scrollable list that fills the space from its own top edge to the bottom of the app shell
// (the fixed, screen-sized container in Layout.js). Measuring replaces hard-coded
// calc(100vh - Npx) heights, which ignored the header, tabs, filters and date bar above the list,
// and the iOS browser toolbars.
// bottomPadding keeps the last row reachable above floating buttons / fixed bottom bars.
const MobileScrollList = ({ children, bottomPadding = 0, style }) => {
  const listRef = useRef(null);
  const [height, setHeight] = useState(null);

  const updateHeight = () => {
    const list = listRef.current;
    if (!list) return;

    const shell = list.closest("[data-app-shell]");
    const visibleHeight = shell ? shell.clientHeight : window.innerHeight;
    setHeight(Math.max(visibleHeight - getTopWithin(list, shell), 0));
  };

  // Re-measure after every render: content above the list (filters, date bar) can change size
  useLayoutEffect(updateHeight);

  useEffect(() => {
    window.addEventListener("resize", updateHeight);
    return () => window.removeEventListener("resize", updateHeight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={listRef}
      style={{
        overflowY: "auto",
        overflowX: "hidden",
        height: height ?? "auto",
        paddingBottom: bottomPadding,
        boxSizing: "border-box",
        ...style,
      }}
    >
      {children}
    </div>
  );
};

// Space to leave for MobileAddButton (58px button, 20px from the bottom)
export const ADD_BUTTON_CLEARANCE = 90;
// Space to leave for the fixed white action bar at the bottom of some pages
export const BOTTOM_BAR_CLEARANCE = 80;

export default MobileScrollList;
